import {
  collection,
  doc,
  addDoc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { Chantier } from '@/types';

export class ChantierService {
  private static collection = 'chantiers';

  static async createChantier(data: Partial<Chantier>, userId: string): Promise<string> {
    const chantierData = {
      ...data,
      developerId: userId,
      verified: false,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      status: 'active',
      units: [],
    };

    const docRef = await addDoc(collection(db, this.collection), chantierData);
    return docRef.id;
  }

  static async getChantiersByDeveloper(developerId: string): Promise<Chantier[]> {
    const q = query(
      collection(db, this.collection),
      where('developerId', '==', developerId),
      orderBy('createdAt', 'desc')
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Chantier[];
  }

  static async getChantierById(id: string): Promise<Chantier | null> {
    const docRef = doc(db, this.collection, id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() } as Chantier;
    }
    return null;
  }
}
